import { Button, Modal } from 'antd';
import React from 'react';

const DeleteAgencyModal = ({
  showModal = false,
  setShowModal,
  title,
  name,
  deleteMutation,
  mutationId,
  setMutationId,
  agencyId,
}) => {
  const handleOk = () => {
    const where = mutationId ? { userId: mutationId, agencyId } : { agencyId };
    deleteMutation({
      variables: {
        where,
      },
    });
  };

  const handleCancel = () => {
    setMutationId('');
    setShowModal(false);
  };
  return (
    <div>
      <Modal
        id="delete-agency-modal"
        maskClosable={false}
        centered
        closable={false}
        footer={null}
        open={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <h2 id="delete-agency-modal-title">{`Remove ${title}`}</h2>
        <p id="delete-agency-confirmation-text">Are you sure you want to remove {name}?</p>
        <div id="delete-agency-form-buttons" className="form-buttons">
          <Button
            id="delete-agency-cancel-btn"
            shape="round"
            className="cancel-button"
            onClick={handleCancel}
          >
            No, Cancel
          </Button>
          <Button
            id="delete-agency-confirm-btn"
            shape="round"
            type="primary"
            className="save-button"
            onClick={handleOk}
          >
            Yes, Remove
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteAgencyModal;
